/**
 * Normalizes the raw genre values produced by legacy data/forms
 * ("Genre 1", "male", "female", ...) into the display labels expected downstream.
 */
export const normalizeGenre = (genre: string | null | undefined): string => {
  if (!genre) return '';
  const val = genre.toLowerCase().trim();
  if (['genre 1', 'male', 'homme', '1'].includes(val)) return 'Masculin';
  if (['genre 2', 'female', 'femme', '2'].includes(val)) return 'Féminin';
  return genre; // valeur inconnue retournée telle quelle
};

export interface ProductionCyclePathParts {
  userId: string;
  projectId: string;
  tpeName: string;
  productionCycleLabel: string;
}

/**
 * Extract parts from a production cycle path string.
 * @param path - Format: userId/projectId/tpeName/productionCycleLabel
 * @returns Parsed parts as an object
 */
export function parseProductionCyclePath(path: string): ProductionCyclePathParts {
  if (!path || typeof path !== 'string') {
    throw new Error('Invalid path');
  }

  const parts = path.split('/');

  if (parts.length !== 4) {
    throw new Error('Path must have exactly 4 parts: userId/projectId/tpeName/productionCycleLabel');
  }

  const [userId, projectId, tpeName, productionCycleLabel] = parts;

  return {
    userId,
    projectId,
    tpeName,
    productionCycleLabel,
  };
}
